var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"api":_vm.api,"columns":_vm.columns,"server-side":false,"list-key":"process_attachment_list","table-id":"attachment_table"},on:{"ready":_vm.onReady}})}
var staticRenderFns = []

export { render, staticRenderFns }